import { IClusterApiModel } from './api/cluster.api.model';
import { IImageApiModel } from './api/image.api.model';
export class ClusterModel {
  id: number;
  slug: string;
  name: string;
  prefix: string;
  motto: string;
  description: string;
  image: string | null;
  whiteLabel: string | null;
  placeIds: Array<number>;
  children: Array<ClusterModel> | null;
  launched: boolean;

  constructor(source?: IClusterApiModel) {
    if (source == null) {
      return;
    }

    this.id = source.id;
    this.slug = source.slug;
    this.name = source.name;
    this.prefix = source.prefix;
    this.motto = source.motto;
    this.description = source.description;
    this.image = source.image;
    this.whiteLabel = source.white_label;
    this.placeIds = source.beacon_ids;
    this.launched = source.launched;
    this.children = Array.isArray(source.children)
      ? source.children.map(item => new ClusterModel(item))
      : [];
  }

  static copyObj(source: Pick<ClusterModel, keyof ClusterModel>): ClusterModel {
    return Object.assign(new ClusterModel(), source);
  }
}
